module.exports = __webpack_public_path__ + "static/media/ini4-180w.aa3284d2.jpg";